export default __webpack_public_path__ + "13f0e4b45e02ec8065e89c0444c388e0.jpg";